import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';

// components
import Pageinate from './pageinate.js';
import './pageinate.css';

var _ref = React.createElement('div', { className: 'collection_image_overlay' });

var PaginateGroup = function (_Component) {
	_inherits(PaginateGroup, _Component);

	function PaginateGroup() {
		_classCallCheck(this, PaginateGroup);

		var _this = _possibleConstructorReturn(this, (PaginateGroup.__proto__ || Object.getPrototypeOf(PaginateGroup)).call(this));

		_this.state = {
			display_num: 20,
			current_page: 1
		};
		_this.incrementPage = _this.incrementPage.bind(_this);
		return _this;
	}

	_createClass(PaginateGroup, [{
		key: 'incrementPage',
		value: function incrementPage() {
			var new_page = this.state.current_page + 1;
			this.setState({ current_page: new_page });
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setState({ display_num: this.props.display_num });
			this.setState({ current_page: this.props.current_page });
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    products = _props.products,
			    filter_tag = _props.filter_tag;
			var _state = this.state,
			    display_num = _state.display_num,
			    current_page = _state.current_page;

			// FILTER
			// logic for filtering by tag

			products = products.filter(function (product) {
				if (filter_tag == 'all') {
					return product;
				} else if (product.node.tags.includes(filter_tag)) {
					return product;
				}
			});
			// ***********************************

			// PAGINATION
			// Logic for displaying products
			var index_of_last_product = current_page * display_num;
			var current_products = products.slice(0, index_of_last_product);
			console.log("INDEX OF LAST", index_of_last_product, products.length);
			var show_load_more = index_of_last_product <= products.length;
			// ***********************************
			return React.createElement(
				'div',
				null,
				React.createElement(
					'div',
					{ className: 'collection_image_grid' },
					current_products.map(function (product, index) {

						return React.createElement(
							'a',
							{ key: product.node.handle + '-' + index, href: '/products/' + product.node.handle },
							React.createElement(
								'div',
								{ className: 'collection_image_wrapper' },
								React.createElement('img', { className: 'collection_image', src: product.node.images.edges[0].node.productImg, alt: product.node.images.edges[0].node.altText }),
								_ref
							),
							React.createElement(
								'div',
								{ className: 'collection_info' },
								React.createElement(
									'p',
									null,
									product.node.title
								),
								React.createElement(
									'p',
									null,
									React.createElement(
										'span',
										{ className: 'price' },
										'$',
										Number(product.node.priceRange.minVariantPrice.amount).toFixed(0)
									),
									' ',
									product.node.priceRange.minVariantPrice.currencyCode
								)
							)
						);
					})
				),
				show_load_more && React.createElement(
					'button',
					{ className: 'button dark collection_load_more', onClick: this.incrementPage },
					'Load More'
				)
			);
		}
	}]);

	return PaginateGroup;
}(Component);

export default PaginateGroup;